import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=d49ea774&"
import script from "./SendMessage.vue?vue&type=script&lang=js&"
export * from "./SendMessage.vue?vue&type=script&lang=js&"
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=d49ea774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports